import { render, staticRenderFns } from "./SaleTable.vue?vue&type=template&id=58f2e938"
import script from "./SaleTable.vue?vue&type=script&lang=js"
export * from "./SaleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports